var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-table"},[_c('div',{staticClass:"head"},[_vm._v("套餐商品信息")]),_c('div',{staticClass:"main"},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.subUserOrderList,"border":""},scopedSlots:_vm._u([{key:"offerFeeSum",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm._f("feetoFixedTwo")(row.offerFeeSum)))])]}},{key:"chargeFee",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm._f("feetoFixedTwo")(row.chargeFee)))])]}},{key:"paySts",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm._f("initPaySts")(row.paySts)))])]}},{key:"classType",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm._f("initClassType")(row.classType)))])]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }